"use client";

import { navMenu } from "@/constants";
import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "../ui/button";
import { useIsMobile } from "@/hooks/useMobile";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { Label } from "../ui/label";

export function SiteHeader() {
  const pathname = usePathname();
  const [open, setOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={cn(
        "sticky top-0 z-40 w-full duration-300",
        isScrolled && "bg-white/70 shadow-md backdrop-blur-sm"
      )}
    >
      <div className="container flex h-20 items-center space-x-4 sm:justify-between sm:space-x-0">
        <div className="flex gap-6 md:gap-24">
          <Link href="/#hero" className="flex items-center space-x-2">
            <Avatar className="size-16">
              <AvatarImage src={`/assets/icons/dprd-pali-logo.png`} />
              <AvatarFallback>Pali</AvatarFallback>
            </Avatar>
            {(!isMobile || isScrolled) && (
              <Label className="font-bold text-lg sm:text-xl">
                SIMSEKWAN DPRD PALI
              </Label>
            )}
            {/* <figure className="flex justify-center items-center gap-x-3">
              <Image
                src={`/assets/icons/dprd-pali-logo.png`}
                width={45}
                height={65}
                alt="logo-dprd-pali"
                className="w-10 h-14 object-cover "
              />
            </figure> */}
          </Link>
          <nav className="hidden gap-6 md:flex">
            {navMenu.map((item, i) => {
              const isActive = item.href === pathname;
              return (
                <Link
                  key={i}
                  href={item.href}
                  className={cn(
                    "flex items-center font-medium text-muted-foreground transition-colors hover:text-foreground text-base ",
                    {
                      "text-primary-700": isActive,
                    }
                  )}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
          {isMobile && (
            <DropdownMenu open={open} onOpenChange={setOpen}>
              <DropdownMenuTrigger asChild>
                <Button className="self-center absolute right-6 p-2 bg-white text-primary">
                  {open ? <X /> : <Menu />}
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                {navMenu.map((item, i) => {
                  const isActive = item.href === pathname;
                  return (
                    <DropdownMenuItem key={i}>
                      {" "}
                      <Link
                        key={i}
                        href={item.href}
                        className={cn({
                          "text-primary-700": isActive,
                        })}
                      >
                        {item.label}
                      </Link>
                    </DropdownMenuItem>
                  );
                })}
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
      </div>
    </header>
  );
}
